import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  Box,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { SideMenu } from '../SideMenu/SideMenu';
import { UserModule } from '../UserModule/UserModule';
import { Logo } from '../Logo/Logo';
import { useAuth } from '../../../../auth/context/AuthContext';
import { logout } from '../../../../auth/services/authService';

interface HeaderProps {
  onNavigate?: (path: string) => void;
}

export const Header: React.FC<HeaderProps> = ({ onNavigate }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuClick = (menuPath: string) => {
    console.log('Navegando a:', menuPath);
    if (onNavigate) {
      onNavigate(menuPath);
    }
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          height: '76px',
          justifyContent: 'center',
        }}
      >
        <Toolbar
          sx={{
            height: '76px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingX: { xs: 2, sm: 3 },
          }}
        >
          {/* Contenedor izquierdo: Menú Hamburguesa + Logo */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {/* Menú Hamburguesa */}
            <IconButton
              color="inherit"
              aria-label="abrir menú"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                color: '#a0588e',
                marginRight: 2,
                '&:hover': {
                  backgroundColor: 'rgba(160, 88, 142, 0.1)',
                },
              }}
            >
              <MenuIcon />
            </IconButton>

            {/* Logo */}
            <Box
              onClick={() => handleMenuClick('/home')}
              sx={{ cursor: 'pointer' }}
            >
              <Logo variant="white" height={58} />
            </Box>
          </Box>

          {/* Módulo de Usuario - Derecha */}
          <UserModule
            userName={user?.displayName || user?.email || 'Usuario'}
            userEmail={user?.email || undefined}
            avatarUrl={user?.photoURL || undefined}
            onLogout={logout}
          />
        </Toolbar>
      </AppBar>

      {/* Menú Lateral */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 280,
          },
        }}
      >
        <SideMenu 
          onClose={handleDrawerToggle} 
          onMenuClick={handleMenuClick}
        />
      </Drawer>
    </>
  );
}; 